import { Component, type ErrorInfo, type ReactNode } from 'react';
import i18next from 'i18next';

interface Props {
    children: ReactNode;
}

interface State {
    failed: boolean;
}

// Contains a crash to the view that caused it: the header, the tabs and the
// other views keep working, and the failed view can be tried again.
export class TabErrorBoundary extends Component<Props, State> {
    state: State = { failed: false };

    static getDerivedStateFromError(): State {
        return { failed: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error('A view crashed', error, info.componentStack);
    }

    render() {
        if (!this.state.failed) {
            return this.props.children;
        }
        return (
            <div className="state-message" role="alert">
                <p>{i18next.t('error_view')}</p>
                <button type="button" onClick={() => this.setState({ failed: false })}>
                    {i18next.t('state_retry')}
                </button>
            </div>
        );
    }
}
